import { SEND_TICKET, SEND_TICKET_DONE, SEND_TICKET_ERROR, RESET_SEND_TICKET } from './actionTypes';
export const sendTicket = (data) => ({
    type: SEND_TICKET,
    data
});
export const sendTicketDone = () => ({
    type: SEND_TICKET_DONE
});
export const sendTicketReset = () => ({
    type: RESET_SEND_TICKET
});
export const sendTicketError = (data) => ({
    type: SEND_TICKET_ERROR,
    data
});
//# sourceMappingURL=actionCreators.js.map